import React, { Suspense } from 'react'
import ReactPixel from 'react-facebook-pixel'
import { isEqual as _isEqual } from 'lodash'
// import moment from 'moment'

import { HelmetComponent, Loading, Modal } from 'components'
import { Toolbar } from '../components'

import config from 'config'
import {
  checkIsStockTWOnly,
  checkSingleSwitchEnabled,
  checkStockInputNeed,
} from './func'

import 'assets/sass/Dashboard/dashboard.scss'


const SingleComponents = React.lazy(() => import('../components/SinglePanel'));

export default class Dashboard extends React.PureComponent {
  // stock5GCkecker = () => {
  //   const { stock, stock_5g_list, onStockSet } = this.props;
  //   const stock5GCheck = stock_5g_list.includes(stock.stock_code);
  //
  //   if (!stock5GCheck) {
  //     onStockSet({ stock_code: '2330', stock_name: '台積電' });
  //   }
  // }

  onAllStocksDelete = () => {
    const { current_fav_group, onFavGroupAllStocksDelete } = this.props;

    onFavGroupAllStocksDelete(current_fav_group);
  }

  componentWillUnmount() {
    this.props.onReset();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      labID,
      affiliatedID,
      lab,
      currentLab,
      currentLabID,
      loadLabFailed,
      stock,
      stock_info,
      // stock_5g_list,
      stock_tw_pool,
      history,
      onCurrentLabDataLoadRequest,
      onLabDataLoadRequest,
      // onStock5GListLoad,
      onStockInfoLoad,
      onStockSet,
    } = this.props;
    // stock info
    const stockCode = stock.stock_code;

   // if (prevProps.labID !== labID) {
   //   if (!lab) {
   //     onLabDataLoadRequest(labID);
   //   }
   // }
    if (prevProps.labID !== labID || !_isEqual(prevProps.lab, lab)) {
      if (!lab) {
        onLabDataLoadRequest(labID);
      } else {
        const isTaiwanOnly = checkIsStockTWOnly(lab);

        if (isTaiwanOnly && !stock_tw_pool?.find((item) => (
          item.stock_code === stock.stock_code
        ))) { onStockSet({ stock_code: '1101', stock_name: '台泥' }); }

        ReactPixel.track('ViewContent', { content_name: lab.title });
      }
    }

    if (prevProps?.currentLabID !== currentLabID
        || !_isEqual(prevProps.currentLab, currentLab)) {
      if (currentLab) {
       // if (currentLab.pathname && currentLab.pathname.includes('5G')) {
       //   if (stock_5g_list.length === 0) {
       //     onStock5GListLoad();
       //   } else {
       //     this.stock5GCkecker();
       //   }
       // }

        ReactPixel.track('ViewContent', { content_name: currentLab.title });
      } else {
        if (affiliatedID) {
          onCurrentLabDataLoadRequest(labID, currentLabID);
        // } else {
        //   if (currentLabID !== labID && !lab) { onLabDataLoadRequest(labID); }
        }
      }
    }

    if (loadLabFailed) { history.replace(`/e-com/product-detail/${labID}`); }

   // if (!_isEqual(prevProps.stock_5g_list, stock_5g_list)) {
   //   this.stock5GCkecker();
   // }

    if (prevProps.stock.stock_code !== stockCode && (!stock_info[stockCode]
        // || moment().isAfter(moment(stock_info[stockCode].time))
      )) {
       onStockInfoLoad(stock.stock_code);
    }
  }

  componentDidMount() {
    const {
      authenticated,
      noAuth,
      labID,
      affiliatedID,
      lab,
      currentLab,
      stock,
      stock_info,
      // stock_5g_list,
      onCurrentLabDataLoadRequest,
      onLabDataLoadRequest,
      // onStock5GListLoad,
      onStockInfoLoad,
    } = this.props;
    // stock info
    const stockCode = stock.stock_code;

    if (!authenticated && !noAuth) { return; }

    if (!lab) { onLabDataLoadRequest(labID); }

    if (affiliatedID && !currentLab) {
      onCurrentLabDataLoadRequest(labID, affiliatedID);
    }

    // if (currentLab && currentLab.pathname
    //     && currentLab.pathname.includes('5G')) {
    //   if (stock_5g_list.length === 0) {
    //     onStock5GListLoad();
    //   } else {
    //     this.stock5GCkecker();
    //   }
    // }

    if (!stock_info[stockCode]
        // || moment().isAfter(moment(stock_info[stockCode].time))
      ) {
      onStockInfoLoad(stockCode);
    }
  }

  render() {
    const {
      authenticated,
      history,

      is_delete_all_fav_stocks,

      is_loading,
      lab,
      labID,
      currentLabID,
      affiliatedID,
      currentLab,

      onFavGroupDataLoad,
    } = this.props;
    const hasAffiliated = lab && lab.master
        && lab.master.affiliated_products.length;
    const currentLabData = currentLab ? currentLab : {};
    const { title, category } = currentLabData;
    const labCategories = config.lab.CATEGORY;
    const isTaiwanOnly = checkIsStockTWOnly(lab);

    let isStockInputNeeded = checkStockInputNeed(lab);
    let singleSwitchEnabled = checkSingleSwitchEnabled(lab);

    if (isStockInputNeeded) {
      isStockInputNeeded = checkStockInputNeed(currentLab);
    }

    if (!singleSwitchEnabled) {
      singleSwitchEnabled = checkSingleSwitchEnabled(currentLab);
    }
    
    return (
      <div className={`ua-dashboard
        ${(!currentLab || !hasAffiliated) ? 'no-multi-lab' : ''}
        ${(category === 0) ? 'customised-lab' : ''}
        ${(category === 5) ? 'portfolio-lab' : ''}
        ${isStockInputNeeded ? '' : 'no-search-lab'}
        ${singleSwitchEnabled ? 'single-switch-enabled' : ''}`}
      >
        <HelmetComponent
          title={`優分析 UAnalyze${category ? ` ${labCategories[category].title}`
              : ''}${title ? `－${title}` : ''}`}
          description={category ? labCategories[category].info : ''}
          href={`/lab/dashboard/${labID}/${affiliatedID ? affiliatedID : ''}/`}
          robots={false}
        />

        <Toolbar
          lab={lab}
          currentLabID={currentLabID}
          currentLab={currentLab}
          category={category}
          history={history}
          isMyFavNeeded={authenticated && isStockInputNeeded}
          isStockInputNeeded={isStockInputNeeded}
          isTaiwanOnly={isTaiwanOnly}
          // callback={this.onSingleSearch}
        />

        {is_loading
          ?
          <Loading />
          :
          <Suspense fallback={<Loading />}>
            <SingleComponents
              labID={labID}
              currentLab={currentLab}
              isTaiwanOnly={isTaiwanOnly}
              singleSwitchEnabled={singleSwitchEnabled}
              history={history}
            />
          </Suspense>}

        <Modal
          id="delete-all-fav-stock"
          customClassName="mobile-height"
          title="刪除全部股票"
          html={
            <div className="delete-all-fav-stock-content margin-top-10vh text-center">
              <i className={`${is_delete_all_fav_stocks ? 'colour-orange' : ''}
                  txt-5em elegant elegant-eleganticons-${is_delete_all_fav_stocks
                  ? '4' : '11'}9`}/>

              <div className="margin-top-20">
                {is_delete_all_fav_stocks ? '刪除成功' : '是否刪除全部股票？'}
              </div>
            </div>
          }
          leaveTxt={is_delete_all_fav_stocks ? '我知道了' : '取消'}
          checkBtn={is_delete_all_fav_stocks
            ?
            null
            :
            <button
              className="submit ua-btn default margin-left-15"
              onClick={this.onAllStocksDelete}
            >
              確定
            </button>
          }
          callback={onFavGroupDataLoad}
        />

        <Modal
          id="stock-add-warning"
          customClassName="mobile-height"
          title="加入股票沒有成功"
          html={
            <div className="stock-add-warning-content margin-top-10vh text-center">
              <i className="txt-5em elegant elegant-eleganticons-81"/>

              <h1>我的最愛每組清單至多加入 50 支股票。</h1>
            </div>
          }
          leaveTxt = "我知道了"
        />
      </div>
    );
  }
}
